import React from "react";
import { useTranslation } from "react-i18next";
import { BarChart, Bar, Tooltip, ResponsiveContainer, CartesianGrid, XAxis, YAxis, Legend } from "recharts";

export const BarChartNoPadding = (props) => {
  const { t } = useTranslation();
  
  return (
    <ResponsiveContainer height={props.height ? props.height : 450} width="100%">
      <BarChart data={props?.data ?? []} barSize={50}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="contracttype" />
        <YAxis />
        <Tooltip cursor={{ fill: "transparent" }} />
        <Legend
          // verticalAlign="top"
          // height={36}
          content={(props) => {
            return (
              <ul className="d-flex justify-content-center">
                {props.payload.map((entry, index) => (
                  <li key={`item-${index}`} className="ms-5 d-flex align-items-center">
                    <div
                      style={{ width: "15px", height: "15px", backgroundColor: `${entry.color}`, marginRight: "5px" }}
                    ></div>
                    {entry.value === "numberofcontractscompleted" && `${t("completed")}`}
                    {entry.value === "numberofcontractspending" && `${t("incompleted")}`}
                  </li>
                ))}
              </ul>
            );
          }}
        />
        <Bar dataKey="numberofcontractscompleted" stackId="a" fill="#10439F" />
        <Bar dataKey="numberofcontractspending" stackId="a" fill="#EB8153" />
      </BarChart>
    </ResponsiveContainer>
  );
};
